import Lottie from 'lottie-react';
import { cn } from '@/lib/utils';
import confettiAnimation from '@/pages/assets/animations/confetti.json';

interface ConcludeAnimationProps {
    className?: string;
    loop?: boolean;
}

export default function ConcludeAnimation({ className, loop = false }: ConcludeAnimationProps) {
    return (
        <Lottie
            animationData={confettiAnimation}
            loop={loop}
            className={cn('w-full h-full', className)}
        />
    );
}
